import React, { useState } from "react";

function NewAssessmentForm({ items = [], onSubmit, more = [], onCancel, scores = [] }) {
    const [model, setModel] = useState({ questions: [], additional: [] });
    const [count, setCount] = useState(0);
    const [confirmed, setConfirmed] = useState(false);

    // On selected
    const onOptionSelected = (question, option, single = false, value = 0) => {
        let newModel = { ...model };
        let found = false;
        for (let i = 0; i < newModel.questions.length; i++) {
            if (question === newModel.questions[i].question) {
                found = true;
                newModel.questions[i].question = question;
                // for single selection
                if (single) {
                    newModel.questions[i].options[0] = option;
                } else {
                    newModel.questions[i].options.push(option);
                }
            }
        }
        if (!found) {
            newModel.questions.push({
                question,
                options: [option],
            });
        }
        setModel(newModel);
        UpdateScore();
    };
    // On deselected
    const onRemove = (question, option, value) => {
        let newModel = { ...model };
        for (let i = 0; i < newModel.questions.length; i++) {
            if (question === newModel.questions[i].question) {
                // Check if the value already exist
                if (newModel.questions[i].options.indexOf(option) !== -1) {
                    const index = newModel.questions[i].options.indexOf(option);
                    newModel.questions[i].options.splice(index, 1);
                    // setCount(prev => prev - value);
                }
            }
        }
        setModel(newModel);
        UpdateScore();
    };
    // on additional
    const onNewAdditional = (prop, value) => {
        let newModel = { ...model };
        let found = false;
        for (let i = 0; i < newModel.additional.length; i++) {
            if (prop === newModel.additional[i].key) {
                found = true;
                newModel.additional[i].value = value;
            }
        }
        if (!found) newModel.additional.push({ key: prop, value });
        setModel(newModel);
    };
    const clean = (text) => {
        return text.replace(/ /g, "_");
    };

    const UpdateScore = () => {
        const _s =
            model.questions.length &&
            model.questions
                .map((o) => o.options)
                .flat(Infinity)
                .map((x) => x.value)
                .reduce((p, i) => p + i);
        setCount(_s);
    };
    if (items.length)
        return (
            <form
                className="fade-in"
                onSubmit={(evt) => {
                    evt.preventDefault();
                    const _score = scores.find((item) => count <= item.max && count >= item.min);
                    onSubmit({
                        ...model,
                        score: {
                            value: count + "",
                            desc: (_score && _score.desc) || "nil",
                        },
                        confirmed,
                        questions: model.questions.map(({ question, options }) => {
                            return {
                                question,
                                options: options.map((o) => o.id),
                            };
                        }),
                    });
                }}
            >
                <div className="row justify-content-center">
                    {items.map((item, idx) => (
                        <div key={idx} className="col-12">
                            <div className="row">
                                <div className="col-4 bg-primary pl-3">
                                    <h5>{item.category.name} </h5>
                                </div>

                                <table className="table table-bordered">
                                    {item.questions.map((item, index) => (
                                        <tr key={index} className="d-flex">
                                            <th scope="row" className="col-4">
                                                {item.name}
                                                <br />
                                                <small className="text-muted">{item.allowMultipleSelection ? "You can select multiple option" : "Select only 1 option"}</small>
                                            </th>
                                            <td className="col-8">
                                                {item.allowMultipleSelection ? (
                                                    <>
                                                        {item.options.map((o, io) => (
                                                            <div key={o.id} className="custom-control custom-checkbox custom-control-inline">
                                                                <input
                                                                    type="checkbox"
                                                                    onChange={({ target }) => {
                                                                        if (target.checked) {
                                                                            onOptionSelected(item.id, o, false, o.value);
                                                                        } else {
                                                                            onRemove(item.id, o, o.value);
                                                                        }
                                                                    }}
                                                                    id={`checkbox-${io}-${index}-${idx}`}
                                                                    value={o.id}
                                                                    name={o.id}
                                                                    className="custom-control-input"
                                                                />
                                                                <label className="custom-control-label" htmlFor={`checkbox-${io}-${index}-${idx}`}>
                                                                    {o.name}
                                                                </label>
                                                            </div>
                                                        ))}
                                                    </>
                                                ) : (
                                                    <>
                                                        {item.options.map((o, io) => (
                                                            <div key={io} className={`custom-control custom-radio ${o.value.length < 10 && "custom-control-inline"}`}>
                                                                <input
                                                                    type="radio"
                                                                    id={`customRadioInline-${io}-${index}-${idx}`}
                                                                    name={item.id}
                                                                    onChange={(e) => {
                                                                        if (e.target.checked) {
                                                                            onOptionSelected(item.id, o, true, o.value);
                                                                        } else {
                                                                            onRemove(item.id, o, o.value);
                                                                        }
                                                                    }}
                                                                    className="custom-control-input"
                                                                />
                                                                <label className="custom-control-label" htmlFor={`customRadioInline-${io}-${index}-${idx}`}>
                                                                    {o.name}
                                                                </label>
                                                            </div>
                                                        ))}
                                                    </>
                                                )}
                                            </td>
                                        </tr>
                                    ))}
                                </table>
                            </div>
                        </div>
                    ))}
                    {more.length > 0 && (
                        <div className="col-md-12 fade-in">
                            <div className="row">
                                <div className="col-4 bg-primary pl-4">
                                    <h5>Additional information</h5>
                                </div>
                            </div>
                        </div>
                    )}

                    <table className="table table-bordered">
                        {more.map((prop, index) => (
                            <tr className="d-flex" key={index}>
                                <th scope="row" className="col-4">
                                    {prop}
                                </th>
                                <td className="col-8">
                                    <textarea
                                        name={clean(prop)}
                                        id={clean(prop)}
                                        className="form-control form-control-textarea"
                                        required
                                        onChange={({ target }) => onNewAdditional(prop, target.value)}
                                        rows="6"
                                        placeholder={prop}
                                    ></textarea>
                                </td>
                            </tr>
                        ))}
                    </table>

                    <div className="col-md-12">
                        {scores.length > 0 &&
                            scores
                                .filter((item) => count <= item.max && count >= item.min)
                                .map((s, si) => (
                                    <div key={si} className={`alert ${s.label}`}>
                                        <strong>
                                            {s.min} - {s.max}
                                        </strong>{" "}
                                        {s.desc}
                                    </div>
                                ))[0]}
                    </div>
                    <div className="col-md-12">
                        <div className="custom-control custom-checkbox custom-control-inline">
                            <input
                                type="checkbox"
                                onChange={({ target }) => {
                                    if (target.checked) {
                                        setConfirmed(true);
                                    } else {
                                        setConfirmed(false);
                                    }
                                }}
                                id="confirmed"
                                name="confirmed"
                                className="custom-control-input"
                            />
                            <label className="custom-control-label" htmlFor="confirmed">
                                Confirm on submission
                            </label>
                        </div>
                    </div>
                    {scores.length > 0 && (
                        <div className="col-md-12 fade-in">
                            <span className="text-muted">Score</span>
                            <h4>{count}</h4>
                        </div>
                    )}
                    <div className="col-md-12">
                        <div className="text-right">
                            <button type="submit" className="mdl-button mdl-button--raised mdl-js-ripple-effect m-l-10 margin-right-10 btn-circle btn-success">
                                Save Assessment
                                <i className="material-icons">arrow_right_alt</i>
                            </button>
                            <button type="button" onClick={onCancel} className="mdl-button mdl-button--raised mdl-js-ripple-effect m-l-10 margin-right-10 btn-circle btn-default">
                                <i className="material-icons text-danger">cancel</i> Cancel
                            </button>
                        </div>
                    </div>
                </div>
            </form>
        );
    else
        return (
            <div className="text-center">
                <h3 className="text-pink">This Assessment hasn't been properly configured!</h3>
            </div>
        );
}
export default NewAssessmentForm;

// const useInline = option => option.length < 10;
